import { Displays, StatusTag } from "components";
import { MISSION_GOAL, MISSION_STATUS } from "utils/constants/options";
import { getAccumulatedLabelEn } from "utils/functions/companyMissionRender";

const MissionProgressSection = ({
  progressData,
  isLeaderboardDisabled,
  onLeaderboardClick,
}) => {
  const isPendingOrRegistration = progressData.status === MISSION_STATUS.PENDING.value || progressData.status === MISSION_STATUS.REGISTRATION.value;
  return (
    <div>
      <div className="progress_code_row">
        <span className="code_label">
          รหัสภารกิจ :
          <span className="code_value">{progressData.mission_code}</span>
        </span>
        <div className="status_area">
          <span className="status_text">สถานะ :</span>
          <StatusTag status={progressData.status} />
        </div>
      </div>
      <div className="progress_section">
        <div className="progress_cards_container">
          <div className="progress_cards_row">
            <Displays.MissionStatCard
              labelTh="จำนวนพนักงานที่เข้าร่วมภารกิจ"
              labelEn="Joined Participants"
              value={isPendingOrRegistration ? '-' : progressData.joined_count}
              percent={isPendingOrRegistration ? 0 : progressData.joined_percent}
            />
            <Displays.MissionStatCard
              labelTh="จำนวนพนักงานที่ยังไม่เข้าร่วมภารกิจ"
              labelEn="Pending Participants"
              value={isPendingOrRegistration ? '-' : progressData.pending_count}
              percent={isPendingOrRegistration ? 0 : progressData.pending_percent}
            />
            <Displays.MissionStatCard
              labelTh="จำนวน Active User ในภารกิจ"
              labelEn="Active Participants"
              value={isPendingOrRegistration ? '-' : progressData.active_count || '-'}
              percent={isPendingOrRegistration ? 0 : progressData.active_percent}
            />
          </div>
        </div>

        <div className="progress_info_section">
          <div className="info_left">
            <Displays.MissionInfoRow
              labelTh="เป้าหมายภารกิจ"
              labelEn="Mission Target"
              showBar={false}
              valuePrefix={
                progressData.mission_goal === MISSION_GOAL.HIGHEST_SCORE.value ? "" : "จำนวน"
              }
              value={
                progressData.mission_goal === MISSION_GOAL.HIGHEST_SCORE.value
                  ? "คะแนนรวมสูงสุด"
                  : progressData.target_amount
              }
              unit={
                progressData.mission_goal === MISSION_GOAL.HIGHEST_SCORE.value
                  ? ""
                  : progressData.target_unit
              }
            />
            <Displays.MissionInfoRow
              labelTh={
                progressData.mission_goal === MISSION_GOAL.HIGHEST_SCORE.value
                  ? `จำนวน${progressData.target_unit}สูงสุด`
                  : `จำนวน${progressData.target_unit}สะสมทั้งหมด`
              }
              labelEn={getAccumulatedLabelEn(progressData.mission_goal, progressData.category)}
              valuePrefix="จำนวน"
              value={isPendingOrRegistration ? '-' : (progressData.accumulated_total || '-')}
              unit={progressData.target_unit}
              percent={isPendingOrRegistration ? 0 : progressData.accumulated_percent}
            />
          </div>

          <div className="info_right">
            <Displays.LeaderboardPreview
              labelTh="ตารางจัดอันดับ Leaderboard"
              labelEn="Leaderboard Overview"
              isDisabled={isLeaderboardDisabled}
              onDetailClick={onLeaderboardClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionProgressSection;
